import { bool, func, shape, string } from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components";
import { borderRadius } from "theme";

import { useFlocknoteAppState } from "Flocknote/state";

import FnrTextButton from "UI/FnrTextButton";

import { useAddUrlParam } from "Utilities/urlParamHooks";

import { useUserChipContext } from "../../UserChip";

const SFnrTextButton = styled(FnrTextButton)`
  max-height: 30px;
  ${borderRadius}
`;

const Option = forwardRef(({ tab, isChild, active, onClick, ...rest }, ref) => {
  const { action, title, icon } = tab;
  const addUrlParam = useAddUrlParam();
  const { isSelected } = useUserChipContext();

  // the loading state is managed by the navigateToTab function in userProfileHandler.js
  const [{ loadingProfileTab }] = useFlocknoteAppState();
  const isLoading = loadingProfileTab === tab.action;

  const legacyTabClassName = `.user_profile_nav_item_${action}`;
  const handleClick = () => {
    if (onClick) {
      // initially only used for the "More" button
      onClick();
      return;
    }

    window.document.querySelector(legacyTabClassName)?.click();
    addUrlParam("profileTab", action);
  };

  const fontSize = isChild ? "md" : "lg";
  const paddingLeft = isChild ? "4px" : 0;
  const marginLeft = isChild ? "-3px" : "-6px";
  const justifyContent = "center";

  return (
    <SFnrTextButton
      fullWidth
      noWrap
      fontSize={fontSize}
      isLoading={isLoading}
      icon={icon}
      onClick={handleClick}
      disabled={!isSelected}
      aria-label={`${title.replace(/\s/g, "-").replace(/\./g, "")}-${
        isSelected ? "Enabled" : "Disabled"
      }`.toLowerCase()}
      ref={ref}
      color="brandFnBlue"
      textColor={active ? undefined : "textBlack"}
      hoverColor="textLight"
      reducedYPadding
      reducedXPadding
      hoverBackgroundColor="blue"
      subtleHover
      $borderRadius={7}
      active={active}
      gap={14}
      paddingLeft={paddingLeft}
      marginLeft={marginLeft}
      scaleContentOnly={true}
      justifyContent={justifyContent}
      {...rest}
    >
      {title}
    </SFnrTextButton>
  );
});

Option.propTypes = {
  tab: shape({
    action: string,
    icon: string,
    title: string,
  }),
  active: bool,
  isChild: bool,
  onClick: func,
};

export default Option;
